export default function applicationSettingsReducer(
  state: any = [],
  action: any
) {
  switch (action.type) {
    case "application_settings":
      return {
        ...state,
        webapiUrl: action.webapiUrl,
        iKey: action.iKey,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/applicationSettingsReducer.tsx